import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ACTORS_QUERY_KEYS } from "Actors/Api/Queries/queryKeys";
import {
  type DocumentUploadRequest,
  postActorsActorIDDocuments,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";

export function useUploadActorDocumentMutation(actorID: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(
      ({ file, displayName }: DocumentUploadRequest) =>
        postActorsActorIDDocuments({ file, displayName }, actorID),
      {
        translationPrefix: getResourcePath(Resources.ApiErrors.DocumentUpload),
      },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ACTORS_QUERY_KEYS.documents(actorID),
      });
    },
  });
}
